import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return localStorage.getItem('dentist_language') || 'th';
  });
  const [translations, setTranslations] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  // Load translations on mount
  useEffect(() => {
    loadTranslations();
  }, []);

  // Save language preference
  useEffect(() => {
    localStorage.setItem('dentist_language', currentLanguage);
  }, [currentLanguage]);

  const loadTranslations = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/language/translations`);
      const data = await response.json();
      if (data.success) {
        setTranslations(data.translations);
      }
    } catch (error) {
      console.error('Failed to load translations:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Toggle language
  const toggleLanguage = () => {
    setCurrentLanguage(prev => prev === 'th' ? 'en' : 'th');
  };

  // Get translation for a key
  const print_lang = useCallback((key, fallback = '') => {
    if (!translations[key]) {
      return fallback || key;
    }
    const translation = currentLanguage === 'th'
      ? translations[key].th
      : translations[key].en;
    return translation || fallback || key;
  }, [currentLanguage, translations]);

  const value = {
    currentLanguage,
    setCurrentLanguage,
    toggleLanguage,
    translations,
    print_lang,
    isLoading
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
